var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1549DC",
    d: "M5.36 1.397c.186-.205.186-.538 0-.743-.185-.205-.486-.205-.672 0L.64 5.128c-.185.206-.185.538 0 .744l4.05 4.474c.185.205.486.205.672 0 .185-.205.185-.538 0-.743L1.648 5.5l3.713-4.103z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.dbca36ca3007751947c4fa31d8768ae4.svg";
export { ForwardRef as ReactComponent };